import React from "react";
import {Trans} from "react-i18next";

const ValidationFeedback = ({error}) => {
  return (
    !!error &&
    <div className={`validationFeedback validationFeedback_${error.message.type}`}>
      <Trans i18nKey={error.message.i18nKey}>{error.message.default}</Trans>
    </div>
  );
};

export default ValidationFeedback;